<app-pcbread-crumb [data]="'Calender'"></app-pcbread-crumb>
<div class="card mb-4 animate__animated animate__backInDown">
  <div class="card-body p-0">
    <div class="row m-2" *ngIf="!loading">
      <div class="col-10">
        <div class="control-verticaly calneder-box pe-0 me-0 p-2 m-1 pt-0 ps-0">
          <div class="row m-0 p-2 week-day">
            <div class="col">
              <div class="card-text">{{ "Saturday" | translate }}</div>
            </div>
            <div class="col">
              <div class="card-text">{{ "Sunday" | translate }}</div>
            </div>
            <div class="col">
              <div class="card-text">{{ "Monday" | translate }}</div>
            </div>
            <div class="col">
              <div class="card-text">{{ "Tuesday" | translate }}</div>
            </div>
            <div class="col">
              <div class="card-text">{{ "Wednesday" | translate }}</div>
            </div>
            <div class="col">
              <div class="card-text">{{ "Thursday" | translate }}</div>
            </div>
            <div class="col">
              <div class="card-text">{{ "Friday" | translate }}</div>
            </div>
          </div>
          <div class="row mt-2 m-0" *ngFor="let week of thisMonth.weeks; let i = index">
            <div class="col" *ngFor="let day of week.days">
              <div class="day-item" [ngClass]="{
                  outOfMonth: (i == 0 && day.day > 7) || (i > 3 && day.day < 16)
                }">
                <div class="row m-0">
                  <div class="col-4 day-number p-0">
                    <span>
                      {{ day.day }}
                    </span>
                  </div>
                  <div class="col-6"></div>
                  <div class="col-2 p-0 btn-add" *ngIf="
                      (i == 0 && day.day <= 7) ||
                      (i > 3 && day.day >= 16) ||
                      (i <= 3 && i > 0)
                    ">
                    <button class="btn-cal" (click)="createNewEvent(day)">
                      <i class="fa fa-plus icon-btn-add" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div class="col-2" *ngIf="(i == 0 && day.day > 7) || (i > 3 && day.day < 16)"></div>
                  <div class="col-12 m-0 p-0 border-bottom border-top"
                    *ngIf="day.events != null && day.events.length > 0">
                    <button class="btn-cal p-1" *ngIf="day.events.length == 1" (click)="showDetailModal(day)">
                      <span class="small mx-1" *ngFor="let item of day.events">
                        {{ item.name }}
                      </span>
                      <i class="fa fa-calendar-check taskList-icon"></i>
                    </button>
                    <button class="btn-cal p-1" *ngIf="day.events.length > 1" (click)="showDetailModal(day)">
                      <span class="small mx-1">
                        {{ 'Event' | translate }}
                      </span>
                      <span class="small mx-1">
                        {{ day.events.length}}
                      </span>
                      <i class="fa fa-calendar-check taskList-icon"></i>
                    </button>
                  </div>
                  <div class="col-12 m-0 p-0 border-bottom" *ngIf="day.factors != null && day.factors.length > 0">
                    <button class="btn-cal p-1">
                      <span class="small mx-1" *ngFor="let item of day.factors">
                        {{ item.name }}
                      </span>
                      <i class="fa-solid fa-list factor-icon"></i>
                    </button>
                  </div>
                  <div class="col-12 m-0 p-0" *ngIf="day.checks != null && day.checks.length > 0">
                    <button class="btn-cal p-1">
                      <span class="small mx-1" *ngFor="let item of day.checks">
                        {{ item.name | number }}
                      </span>
                      <i class="fa-solid fa-money-check check-icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2 ps-0">
        <div class="control-verticaly calneder-box left-box ps-0 ms-0 p-2 m-1">
          <div class="row ps-2 my-1">
            <div class="col-12 text-center py-1">
              <div class="header-text">
                <span class="label">{{ "Year" | translate }}</span>
              </div>
            </div>
            <div class="col-2 icon-arrow-right">
              <button class="btn btn-icon btn-secondary" (click)="nextYear()">
                <i class="fa fa-angle-right"> </i>
              </button>
            </div>
            <div class="col-8">
              <input class="form-control" type="number" [(ngModel)]="thisYearNumber" (change)="setMonth()" />
            </div>
            <div class="col-2 icon-arrow-left">
              <button class="btn btn-icon btn-secondary" (click)="previousYear()">
                <i class="fa fa-angle-left"></i>
              </button>
            </div>
            <div class="col-12">
              <hr />
            </div>
            <div class="col-12 text-center py-1">
              <div class="header-text">
                <span class="label">{{ "Month" | translate }}</span>
              </div>
            </div>
            <div class="col-2 icon-arrow-right">
              <button class="btn btn-icon btn-secondary" (click)="previousMonth()">
                <i class="fa fa-angle-right"> </i>
              </button>
            </div>
            <div class="col-8">
              <select class="form-select" [(ngModel)]="thisMonthNumber" (change)="setMonth()">
                <option value=""></option>
                <option value="1">{{ "Farvardin" | translate }}</option>
                <option value="2">{{ "Ordibehesht" | translate }}</option>
                <option value="3">{{ "Khordad" | translate }}</option>
                <option value="4">{{ "Tir" | translate }}</option>
                <option value="5">{{ "Mordad" | translate }}</option>
                <option value="6">{{ "Shahrivar" | translate }}</option>
                <option value="7">{{ "Mehr" | translate }}</option>
                <option value="8">{{ "Aban" | translate }}</option>
                <option value="9">{{ "Azar" | translate }}</option>
                <option value="10">{{ "Dey" | translate }}</option>
                <option value="11">{{ "Bahman" | translate }}</option>
                <option value="12">{{ "Esfand" | translate }}</option>
              </select>
            </div>
            <div class="col-2 icon-arrow-left">
              <button class="btn btn-icon btn-secondary" (click)="nextMonth()">
                <i class="fa fa-angle-left"></i>
              </button>
            </div>
            <div class="col-12">
              <hr />
            </div>
            <div class="col-12 text-center py-1">
              <div class="header-text">
                <span class="top-lable label">{{ "filter" | translate }}</span>
              </div>
            </div>
            <div class="col-4">
              <label class="top-lable" for="checks">{{
                "Check" | translate
                }}</label>
              <input id="checks" type="checkbox" class="form-check-input" [(ngModel)]="checkFilter"
                (change)="setOnMonth()" />
            </div>
            <div class="col-4">
              <label class="top-lable" for="factor">{{
                "Factor" | translate
                }}</label>
              <input id="factor" type="checkbox" class="form-check-input" [(ngModel)]="factorFilter"
                (change)="setOnMonth()" />
            </div>
            <div class="col-4">
              <label class="top-lable" for="event">{{
                "event" | translate
                }}</label>
              <input id="event" type="checkbox" class="form-check-input" [(ngModel)]="eventFilter"
                (change)="setOnMonth()" />
            </div>
            <div class="col-12">
              <hr />
            </div>
            <div class="col-12 my-2">
              <div class="header-text">
                <span>{{ "checksAmountInMonth" | translate }}</span>
              </div>
            </div>
            <div class="col-12 text-center">
              <div class="box-show-sum">
                <span>{{ sumOfCheck | dataType : '' }}</span>
              </div>
            </div>
            <div class="col-12">
              <hr />
            </div>
            <div class="col-12 my-2">
              <div class="header-text">
                <span>{{ "factorsAmountInMonth" | translate }}</span>
              </div>
            </div>
            <div class="col-12 text-center">
              <div class="box-show-sum">
                <span>{{ sumOfFactor | dataType : '' }}</span>
              </div>
            </div>
            <div class="col-12">
              <hr />
            </div>
            <div class="col-12 my-2">
              <div class="header-text">
                <span>{{ "eventsCountInMonth" | translate }}</span>
              </div>
            </div>
            <div class="col-12 text-center">
              <div class="box-show-sum">
                <span>{{ countOfEvent }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-loading-panel *ngIf="loading"></app-loading-panel>
</div>

<ng-template #newEventModal let-modal class="modal modal-top fade modal-size">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "NewEvent" | translate }}
    </h6>
    <button type="button" class="btn-close-modal btn-icon btn-close" (click)="modal.dismiss('Cross click')"
      aria-label="Close"></button>
  </div>

  <div class="modal-body">
    <div class="card-modal">
      <div class="row mx-3 my-0 modal-body-row">
        <div class="col-3 fs-6 fw-bold">
          <label for="eventSubject" class="form-label">
            {{ "eventSubject" | translate }}:
          </label>
        </div>
        <div class="col-9 fs-6 fw-bold">
          <input type="text" class="form-control" [(ngModel)]="backEndJson.name" />
        </div>
      </div>
      <div class="row mx-3 my-0">
        <div class="col-12 top-input-box mt-3">
          <label for="description" class="form-label m-0">{{ "description" | translate }}:</label>
          <textarea id="description" type="text" class="form-control" placeholder="{{ 'description' | translate }}"
            [(ngModel)]="backEndJson.description">
          </textarea>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer border-top p-3">
    <button type="submit" class="btn btn-primary me-sm-3 me-1 data-submit" (click)="submitModal()">
      {{ "Submit" | translate }}
    </button>
    <button type="reset" class="btn btn-label-secondary" (click)="modal.dismiss('Cross click')">
      {{ "Cancel" | translate }}
    </button>
  </div>

  <app-loading-panel *ngIf="modalLoading"></app-loading-panel>

</ng-template>

<app-pcsuccess-modal [showModal]="modalSuccessConfirm" (parentAction)="parentAction($event)">
</app-pcsuccess-modal>

<ng-template #viewDetailModal let-modal class="modal modal-top fade">


  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "Delete" | translate }}
    </h6>
    <button type="button" class="btn-close-modal btn-icon btn-close" (click)="modal.dismiss('Cross click')"
      aria-label="Close"></button>
  </div>

  <div class="modal-body" >
    <div *ngIf="modalDeleteConfirm">

      <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
        <div class="swal2-icon-content">
          !
        </div>
      </div>
      <img class="swal2-image" style="display: none;">
      <h2 class="swal2-title" id="swal2-title" style="display: block;">
        {{"Confirmation" | translate}}
      </h2>
      <!-- <div class="swal2-html-container" id="swal2-html-container" style="display: block;">
        {{ "Delete" | translate }}
      </div> -->

      <label for="swal2-checkbox" class="swal2-checkbox" style="display: none;">
        <input type="checkbox">
        <span class="swal2-label">
        </span>
      </label>
      <div class="swal2-actions">
        <div class="swal2-loader">
        </div>
        <button type="button" class="swal2-confirm btn btn-primary me-3" style="display: inline-block;" aria-label=""
          (click)="submitDelete()">{{'Confirm' | translate}}</button>
        <button type="button" class="swal2-deny" style="display: none;" aria-label="">{{'No' | translate}}</button>
        <button type="button" class="swal2-cancel btn btn-label-secondary" style="display: inline-block;" aria-label=""
          (click)="NotDelete()">
          {{'Cancel' | translate}}
        </button>
      </div>
      <div class="swal2-footer" style="display: none;"></div>
      <div class="swal2-timer-progress-bar-container">
        <div class="swal2-timer-progress-bar" style="display: none;"></div>
      </div>
    </div>
    <app-pctable *ngIf="!modalDeleteConfirm" [data]="data" (parentAction)="parentAction($event)"></app-pctable>
  </div>

</ng-template>